import { FC } from 'react';
import { MapPin, Users, Eye } from 'lucide-react';
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { Badge } from "@/components/ui/badge";
import { BaseEventCard, EventActionsMenu } from './BaseEventCard';

interface CustomAdventureCardProps {
  title: string;
  totalParticipants: number;
  customerName?: string;
  isMonthView: boolean;
  isMenuOpen: boolean;
  onMenuOpenChange: (open: boolean) => void;
  onViewDetails: () => void;
  onMouseEnter?: (e: React.MouseEvent) => void;
  onMouseLeave?: () => void;
  children?: React.ReactNode; // For hover card
}

export const CustomAdventureCard: FC<CustomAdventureCardProps> = ({
  title,
  totalParticipants,
  customerName,
  isMonthView,
  isMenuOpen,
  onMenuOpenChange,
  onViewDetails,
  onMouseEnter,
  onMouseLeave,
  children
}) => {
  // Participant count component
  const participantCount = totalParticipants > 0 ? (
    <div className="flex-shrink-0 flex items-center gap-0.5 px-1.5 py-0.5 bg-emerald-700/30 text-emerald-100 border border-emerald-600/50 rounded text-xs font-medium">
      <Users className="w-2.5 h-2.5 flex-shrink-0" />
      <span>{totalParticipants}</span>
    </div>
  ) : null;

  // Customer name for week/day view
  const customerInfo = (!isMonthView && customerName) ? (
    <div className="text-xs text-emerald-100 truncate opacity-90">
      {customerName}
    </div>
  ) : null;

  // Adventure badge for month view
  const adventureBadge = isMonthView ? (
    <Badge 
      variant="secondary" 
      className="flex-shrink-0 text-xs bg-emerald-700/30 text-emerald-100 border-emerald-600/50 px-1.5 py-0.5"
    >
      ADV
    </Badge>
  ) : null;

  return (
    <BaseEventCard
      theme="adventure"
      isMonthView={isMonthView}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      icon={<MapPin className="w-3 h-3 text-emerald-100 flex-shrink-0" />}
      title={title}
      actionsMenu={
        <EventActionsMenu
          theme="adventure"
          isOpen={isMenuOpen}
          onOpenChange={onMenuOpenChange}
        >
          <DropdownMenuItem onClick={onViewDetails} className="flex items-center gap-2">
            <Eye className="h-4 w-4" />
            View Booking Details
          </DropdownMenuItem>
        </EventActionsMenu>
      }
      leftContent={
        <div className="flex items-center gap-2">
          {participantCount}
          {customerInfo}
        </div>
      }
      rightContent={adventureBadge}
    >
      {children}
    </BaseEventCard>
  );
};
